// Author YuJiaBei
// Date 2020-12-02 16:57:55

import * as model from "@/model/em/admin/EmAdmNotificationModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmAdmNotification(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_ADMIN_URL,
    })
    .buildStore()
